'use client';

import { memo, Children, isValidElement } from 'react';
import clsx from 'clsx';
import { ComponentMemo } from '@headless-workspace/typings';
import { DividerDirection } from '../../atoms';
import { CardDirection, CardProps, CardSize, CardStyle, CardType, ComposableCard } from '../../newComposables';

export const GlowCard: ComponentMemo<CardProps> = memo(
    ({ children, TagName = 'div', image, className, content, direction, size = CardSize.M, ...props }) => {
        const isArray = Array.isArray(children);

        const contentElements = Children.toArray(children)
            .filter((child) => isValidElement(child))
            .map((child, index) => (
                <div key={`content-${index}`} className={clsx('flex w-full', CardStyle.padding({ size }))}>
                    {child}
                </div>
            ));

        const cardContent = isArray ? (
            contentElements.flatMap((child, index) =>
                index > 0
                    ? [
                          <ComposableCard.Separator key={`divider-${index}`} direction={DividerDirection.Horizontal} />,
                          child,
                      ]
                    : [child],
            )
        ) : (
            <>
                <ComposableCard.Image {...image} />
                <ComposableCard.Content hasImage={!!image} {...content}>
                    {children}
                </ComposableCard.Content>
            </>
        );

        const cardDirection = isArray ? CardDirection.Col : direction;

        return (
            <ComposableCard.Root type={CardType.Card} direction={cardDirection} size={size}>
                <ComposableCard.Container
                    TagName={TagName}
                    className={clsx(CardStyle.backgroundCard({ ...props }), className, isArray && '!gap-0')}
                    {...props}
                >
                    {cardContent}
                </ComposableCard.Container>
            </ComposableCard.Root>
        );
    },
);

GlowCard.displayName = 'GlowCard';
